import React from 'react';
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text,
} from '@chakra-ui/react';
import { FAQItem } from '../types';

interface FAQItemPresentationProps {
  item: FAQItem;
  index: number;
  totalItems: number;
  borderColor: string;
}

const FAQItemPresentation: React.FC<FAQItemPresentationProps> = ({
  item,
  index,
  totalItems,
  borderColor
}) => {
  return (
    <AccordionItem 
      borderTop={index === 0 ? 'none' : `1px solid ${borderColor}`}
      borderBottom={index === totalItems - 1 ? 'none' : `1px solid ${borderColor}`}
    >
      <h3>
        <AccordionButton py={4}>
          <Box flex="1" textAlign="left" fontWeight="semibold">
            {item.question}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h3>
      <AccordionPanel pb={4}>
        <Text color="gray.600">{item.answer}</Text>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default FAQItemPresentation;